<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>系统ID：</label>
                    <el-input v-model="search_Obj.f_system_id" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>第三方用户名：</label>
                    <el-input v-model="search_Obj.f_third_username" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>本平台用户名：</label>
                    <el-input v-model="search_Obj.f_username" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>状态：</label>
                    <el-select v-model="search_Obj.f_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('userstate')" :key="'userstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
            </div>
            <el-card class="box-card">
                <div class="mainBody">
                    <div class="btnBox">
                        <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                    </div>
                    <div class="dataBox">
                        <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                            <el-table-column type="selection" align="center" width="50"></el-table-column>
                            <el-table-column prop="system_id" label="系统ID" sortable="custom"></el-table-column>
                            <el-table-column prop="third_username" label="第三方用户名" sortable="custom"></el-table-column>
                            <el-table-column prop="username" label="本平台用户名" sortable="custom"></el-table-column>
                            <el-table-column prop="state" label="状态" sortable="custom" width="120">
                                <template slot-scope="scope">
                                    <span>{{ transEnu(scope.row.state, "userstate") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="add_time" label="添加时间" sortable="custom"></el-table-column>
                            <el-table-column label="操作" width="180" align="center">
                                <template slot-scope="scope">
                                    <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pageBox">
                        <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :page-size="20" :total="total" @current-change="pageChange"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看单点登录用户"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'singleSignOnList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '单点登录用户',
            menu_id: 1170,
            list_url: "/api/admin/singlesignon/list",
            search_Obj: {
                f_system_id: '',
                f_third_username: '',
                f_username: '',
                f_state: '',
            },
            del_Obj:{
                url:'/api/admin/singlesignon/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['userstate'],
        };
    },
    methods: {}
};
</script>